import { MSC_TERMS } from '../../pages/Booking/termsData';
import React, { useMemo, useState, useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';

// 컴포넌트
import CommonNavComponent from '../Common-components/NavigatorBar/CommonNavComponent';

// NavigatorContents 컴포넌트들
import NavScheduleContent from '../Common-components/NavigatorBar/NavigatorContents/navScheduleContent';
import NavInfoContent from '../Common-components/NavigatorBar/NavigatorContents/navInfoContent';
import NavFacilityContent from '../Common-components/NavigatorBar/NavigatorContents/navFacilityContent';
import NavBenefits from '../Common-components/NavigatorBar/NavigatorContents/navBenefits';
import NavCautionContent from '../Common-components/NavigatorBar/NavigatorContents/navCautionContent';
import NavTermsNRefundsContent from '../Common-components/NavigatorBar/NavigatorContents/navTermsNRefundsContent';
import { DEFAULT_CAUTION, MSC_CAUTION, NORWEGIAN_CAUTION, ROYAL_CARIBBEAN_CAUTION, DISNEY_CAUTION } from '../../utils/cautionData';
import { EXTRA_LINE_BENEFITS_BY_ID } from '../../utils/cruiseLineBenefits';
import { openKakaoChat } from '../../utils/kakaoChat';
import { withMscBellissimaCancelNotice } from '../../utils/mscBellissimaCancelNotice';

// CSS
import '../../css/Detail/detailBody.css';

// media
import circleArrow from '../../assets/icons/svg/arrowCircle.svg';

const SHOW_PARLOR_IMAGES = false; // 선실 이미지를 펼치는 화살표는 기본 비노출

const CONTACT_MESSAGE = '실시간 요금 확인 및 예약을 원하시는 경우\n(주)와우크루즈 고객센터(1660-0696)로 문의해 주시기 바랍니다.';
const MSC_LINE_ID = 16;
const NORWEGIAN_LINE_ID = 17;
const ROYAL_CARIBBEAN_LINE_ID = 22;
const DISNEY_LINE_ID = 73;

const DEFAULT_BENEFITS = [
  {
    title: "",
    items: [
      "매일 밤 펼쳐지는 크루즈 공연",
      "특별 공연 및 선내 프로그램",
      "전일정 선내 뷔페식 & 정찬식 식사",
      "크루즈 숙박 선실료",
      "부대시설 이용료 (일부 유료시설 제외: 면세점, 스파 등)",
      "인솔자가사 경비",
      "DB손해보험 최대 1억원 (A형)",
      "특별 공연 및 선내 프로그램"
    ]
  },
  {
    title: "미니 스위트 객실 ONLY 포함",
    items: [
      "크루즈 선내 팁",
      "일본 출국세",
      "5/25일 부산 도착 후 최윤석 하선"
    ]
  },
  {
    title: "스위트, 그랜드 스위트 객실 ONLY 포함",
    items: [
      "크루즈 선내 팁",
      "일본 출국세",
      "여행 중 음주/주류 패키지 (마이 드링크 +)",
      "웰컴과일 (객실 또는 까나페 & 샴페인 1병)",
      "5/30일 부산 도착 후 최윤석 하선"
    ]
  }
];

const MSC_BENEFITS = [
  {
    title: "MSC 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스-벨라 예약 시 배달비 별도)",
      "뷔페 내 물, 커피, 차, 주스 등의 기본음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const NORWEGIAN_BENEFITS = [
  {
    title: "노르웨이지안 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스 등)",
      "물, 커피, 차, 주스 등의 기본음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const ROYAL_CARIBBEAN_BENEFITS = [
  {
    title: "로얄캐리비안 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스 등)",
      "물, 커피, 차, 주스 등의 기본음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const DISNEY_BENEFITS = [
  {
    title: "디즈니 크루즈 기본혜택",
    items: [
      "객실 정비 서비스 (룸 클리닝)",
      "아침/점심/저녁 식사 (정찬, 뷔페, 조식 룸 서비스 등)",
      "물, 커피, 차, 주스 등 기본음료와 탄산음료",
      "선내 공연 및 다양한 액티비티 프로그램",
      "수영장, 피트니스 센터를 포함한 다양한 편의시설",
      "어린이/청소년 프로그램 등"
    ],
    notes: [
      "※ 선실 타입별 포함 사항이 상이하오니, 자세한 내용은 문의 바랍니다."
    ]
  }
];

const DEFAULT_TERMS = [
  {
    title: "특별 약관",
    description: "본 상품의 취소는 국외여행 표준약관 제16조 외에 약관 제6조에 의해 '국외여행 특별약관'이 적용됩니다. 특별약관은 표준약관보다 높은 취소료가 부과될 수 있으니 세부기준을 반드시 확인하셔야 합니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ],
    extra: {
      type: "link",
      text: "약관 상세 보기 >",
      url: "#"
    }
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      "출항~ 91일 전 취소 시(예약일~2월 28일): 위약금 없음",
      "출항 90일 ~ 61일 전 취소 시(3월 1일~3월 30일): 여행경비의 30%",
      "출항 60일 ~ 31일 전 취소 시(3월 31일~4월 29일): 여행경비의 50%",
      "출항 30일 ~ 출발 당일 취소 시(4월 30일 이후): 여행경비의 100%"
    ],
    extra: {
      type: "notes",
      notes: [
        "*취소 접수는 업무시간 내에 유선 접수만 가능합니다.",
        "*접수시간: 월~금 9:30~15:00, 토/일요일 공휴일 제외"
      ]
    }
  }
];


const NORWEGIAN_TERMS = [
  {
    title: "특별 약관",
    description: "※ 노르웨이지안 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 노르웨이지안 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[취소료 규정]" },
      "90일 전 : 무료",
      "89일 - 75 일 전 : 예약금 (총 요금의 20%)",
      "74일 - 50일 전 : 총 요금의 25%",
      "49일 - 29일 전 : 총 요금의 50%",
      "28일 - 15일 전 : 총 요금의 75%",
      "14일 - 출발일 : 총 요금의 100%",
      { type: "note", text: "※ BOGOFREE 프로모션(1번째 승객 요금 결제 시 2번째 승객은 무료, 단 세금은 별도 부담)의 경우, 지불된 예약금은 환불이 불가능합니다. 할인된 예약금(Reduced Deposit) 프로모션은 스위트(Suite) 및 헤이븐(Haven) 카테고리에는 적용되지 않습니다. 따라서 스위트 또는 헤이븐으로 업그레이드할 경우, 예약금 전액을 즉시 납부해야 합니다." },
      { type: "note", text: "※ 예약 확정 후 모든 변경 요청은 취소료 부과 이전 시점에만 가능하며, 취소료 부과 시점 이후에는 모든 예약 변경이 불가능합니다." },
      { type: "note", text: "※ 선실 요금의 25%, 50% 시점에 부과되는 취소료가 예약금보다 낮을 경우, 예약금이 취소료로 부과됩니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

const ROYAL_CARIBBEAN_TERMS = [
  {
    title: "특별 약관",
    description: "※ 로얄캐리비안 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 로얄캐리비안 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "note", text: "로얄캐리비안 크루즈의 취소 규정은 크루즈 출항일과 일정 길이에 따라 다르게 적용됩니다." },
      { type: "note", text: "예약금은 상품 및 프로모션 조건에 따라 환불 불가(NRD)로 적용될 수 있습니다." },
      { type: "note", text: "예약 변경 또는 취소를 원하실 경우, 아래 규정을 반드시 확인해주시기 바랍니다." },
      { type: "label", text: "[1- 5박 일정]" },
      "75일 전: 무료 (단, 예약금 환불불가 조건은 1인당 USD 150)",
      "74 - 60일 : 예약금",
      "59 - 30일 : 총 요금의 50%",
      "29 - 15일 : 총 요금의 75%",
      "14 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[6박 - 9박 일정]" },
      "90일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 350)",
      "89 - 75일 : 예약금",
      "74 - 45일 : 총 요금의 50%",
      "44 - 15일 : 총 요금의 75%",
      "14 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[10박 - 14박 일정]" },
      "90일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 500)",
      "89 - 75일 : 예약금",
      "74 - 61일 : 총 요금의 50%",
      "60 - 31일 : 총 요금의 75%",
      "30 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[15박 이상 일정]" },
      "121일 전 : 무료 (단, 예약금 환불불가 조건은 1인당 USD 500)",
      "120 - 61일 : 총 요금의 25%",
      "60 - 41일 : 총 요금의 50%",
      "40 - 25일 : 총 요금의 75%",
      "24 - 출발 당일 : 총 요금의 100%",
      { type: "label", text: "[예약금 안내]" },
      { type: "note", text: "*1~5박: 1인당 USD 150" },
      { type: "note", text: "*6~9박: 1인당 USD 350" },
      { type: "note", text: "*10박 이상: 1인당 USD 500" },
      { type: "note", text: "*스위트: 크루즈 요금의 10% 또는 위 금액 중 큰 금액" },
      { type: "note", text: "*아이콘호 STAR 등급: 1인당 USD 600" },
      { type: "note", text: "※ 예약금 환불 불가(NRD) 조건으로 예약하신 경우, 결제하신 예약금은 환불되지 않습니다." },
      { type: "note", text: "※ 선실 요금의 25%, 50% 시점에 부과되는 취소료가 예약금보다 낮을 경우, 예약금 금액이 취소료로 부과됩니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

const DISNEY_TERMS = [
  {
    title: "특별 약관",
    description: "※ 디즈니 크루즈는 일반 해외여행시 적용되는 국외여행표준약관이 아닌 특별 크루즈 약관에 따라 취소 규정이 적용됩니다. 이 규정은 디즈니 크루즈 이용시 전세계에 공통 적용되는 규정입니다. 이에 따른 취소료 규정을 꼭 확인해주시기 바랍니다.",
    items: [
      "취소료는 크루즈 선사 규정을 따르며 예외사항이 없습니다.",
      "예약금 이상의 취소료가 발생하는 시점부터는 차액을 추가로 납부하셔야 합니다."
    ]
  },
  {
    title: "취소료 규정",
    description: "",
    items: [
      { type: "label", text: "[1- 5박 일정]" },
      { type: "label", text: "*내측 / 오션뷰 / 베란다" },
      "예약일 - 90일 전 : 무료",
      "89일 - 45일 전 : 예약금 (총 요금의 10%)",
      "44일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "*컨시어지 / 스위트" },
      "예약일 - 45일 전 : 예약금 (총 요금의 10%)",
      "44일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "[6박 이상 일정]" },
      { type: "label", text: "*내측 / 오션뷰 / 베란다" },
      "예약일 - 120일 전 : 무료",
      "119일 - 56일 전 : 예약금 (총 요금의 10%)",
      "55일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "label", text: "*컨시어지 / 스위트" },
      "예약일 - 56일 전 : 예약금 (총 요금의 10%)",
      "55일 - 30일 전 : 총 요금의 50%",
      "29 - 15일 전 : 총 요금의 75%",
      "14 - 출발일 : 총 요금의 100%",
      { type: "note", text: "※ 인사이드 개런티, 오션뷰 개런티, 베란다 개런티 등급으로 예약 시, 크루즈 요금은 100% 환불 불가합니다." },
      { type: "note", text: "예약 확정을 위한 예약금은 크루즈 요금의 10%입니다." },
      { type: "note", text: "※ 예약 후 모든 변경이 불가능하며, 예약 규정에 따라 취소료가 발생합니다." },
      { type: "note", text: "※ 취소 요청 접수 시간은 평일 09:30 ~ 15:00(토, 공휴일 휴무)입니다. 접수시간 이후 취소 요청은 다음 영업일 기준으로 취소 처리가 진행 되며, 이에 따른 취소료가 적용됩니다." }
    ]
  }
];

function DetailBody({ config, parlorPrices = [], reservationFlag }) {
  const navigate = useNavigate();

  // --- Portal & Mobile ---
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 651);
  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 651);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const footerEl = document.querySelector('.footer');
    if (!footerEl) return;
    const container = document.createElement('div');
    container.id = 'detail-body-portal';
    footerEl.parentNode.insertBefore(container, footerEl.nextSibling);
    setPortalContainer(container);
    return () => {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };
  }, []);

  useLayoutEffect(() => {
    if (!portalContainer) return;
    const wrapper = portalContainer.firstElementChild;
    if (wrapper && isMobile) {
      const h = wrapper.getBoundingClientRect().height;
      portalContainer.style.paddingTop = `${h}px`;
    } else {
      portalContainer.style.paddingTop = '0px';
    }
  }, [portalContainer, isMobile]);
  // --- End Portal & Mobile ---

  // 1. API 데이터에 렌더링할 컴포넌트 정보를 추가합니다.
  const categoriesWithComponent = useMemo(() => {
    const data = config;
    if (!data) return [];

    const definedCategories = [
      { id: 'schedule', name: '여행일정' },
      { id: 'shipInfo', name: '선박/선실 정보' },
      { id: 'benefit', name: '기본혜택' },
      { id: 'facility', name: '부대시설' },
      { id: 'caution', name: '주의사항' },
      { id: 'term', name: '약관/환불' },
    ];

    const lineId = Number(data?.schedule?.line_id ?? 0);
    const isMscLine = lineId === MSC_LINE_ID;
    const isNorwegianLine = lineId === NORWEGIAN_LINE_ID;
    const isRoyalCaribbeanLine = lineId === ROYAL_CARIBBEAN_LINE_ID;
    const isDisneyLine = lineId === DISNEY_LINE_ID;
    const extraLineBenefits = EXTRA_LINE_BENEFITS_BY_ID[lineId];
    const mscCancelNoticeContext = {
      lineId,
      shipId: data.schedule.ship_id,
      sailDate: data.schedule.saildate,
      departurePort: data.schedule.departure_port_name,
      arrivalPort: data.schedule.arrival_port_name,
    };

    return definedCategories.map(category => {
      let componentData = {};
      let ComponentToRender = null;

      switch (category.id) {
        case 'schedule':
          componentData = {
            simple: [
              { date: data.schedule.saildate, type: 'departure', location: data.schedule.departure_port_name },
              { date: data.schedule.enddate, type: 'arrival', location: data.schedule.arrival_port_name },
            ],
            map: data.schedule.itinerary_image_url, // 항해 지도
            detail: data.itinerary, // 상세 항해 일정
          };
          ComponentToRender = NavScheduleContent;
          break;
        case 'shipInfo':
          componentData = {
            shipImage : data.schedule.ship_main_image,
            shipBrand : data.schedule.ship_name_ko || data.schedule.ship_name_en,
            shipIcon : data.schedule.logo_image_url,
            cabinData: Object.values(
              (data.cabin_types || []).reduce((acc, cabin) => {
                const { cabintype, cabintype_ko } = cabin;
                const type = cabintype_ko || cabintype; // cabintype_ko가 없으면 cabintype(영문)
                if (!acc[type]) {
                  acc[type] = {
                    cabinType: type,
                    image: cabin.image_url,
                    cabins: [],
                  };
                }
                acc[type].cabins.push(cabin);
                return acc;
              }, {})
            ),
            infoData : [
              {label:'건조년도',value: `${(data.schedule.launched || '').split('-')[0]}년`},
              {label:'톤수', value: `${Number(data.schedule.tonnage || '' ).toLocaleString()}톤`},
              {label:'총 승선객',value: `${Number(data.schedule.occupancy || '').toLocaleString()}명`},
              {label:'총 승무원',value: `${Number(data.schedule.totalcrew || '').toLocaleString()}명`},
              {label:'객실 수',value: `${Number(data.schedule.totalcabins || '').toLocaleString()}개`}
            ]
          };
          ComponentToRender = NavInfoContent;
          break;
        case 'facility':
          componentData = { data : data.facilities };
          ComponentToRender = NavFacilityContent;
          break;
        case 'benefit': // 더미데이터와 동일하게 구성되어있습니다. navBenefits.js prop수정 필요
          componentData = {
            benefit: extraLineBenefits || (isMscLine
              ? MSC_BENEFITS
              : (isNorwegianLine
                ? NORWEGIAN_BENEFITS
                : (isRoyalCaribbeanLine
                  ? ROYAL_CARIBBEAN_BENEFITS
                  : (isDisneyLine ? DISNEY_BENEFITS : DEFAULT_BENEFITS))))
          };
          ComponentToRender = NavBenefits;
          break;
        case 'caution':
          componentData = {
            caution: isMscLine
              ? MSC_CAUTION
              : (isNorwegianLine
                ? NORWEGIAN_CAUTION
                : (isRoyalCaribbeanLine
                  ? ROYAL_CARIBBEAN_CAUTION
                  : (isDisneyLine ? DISNEY_CAUTION : DEFAULT_CAUTION)))
          };
          ComponentToRender = NavCautionContent;
          break;
        case 'term':
          componentData = {
            term: isMscLine
              ? withMscBellissimaCancelNotice(MSC_TERMS, mscCancelNoticeContext)
              : (isNorwegianLine
                ? NORWEGIAN_TERMS
                : (isRoyalCaribbeanLine
                  ? ROYAL_CARIBBEAN_TERMS
                  : (isDisneyLine ? DISNEY_TERMS : DEFAULT_TERMS)))
          };
          ComponentToRender = NavTermsNRefundsContent;
          break;
        default:
          ComponentToRender = null;
        }

        return {
          ...category,
          Component: ComponentToRender,
          data: componentData, // 해당 컴포넌트에 전달될 데이터
        };
      }).filter(category => category.Component !== null); // 유효한 컴포넌트만 필터링
  }, [config]);

  // useMemo - 객실 타입 및 가격 처리
  const parlors = useMemo(() => {
    const cabinTypes = config.cabin_types ?? [];
    if (cabinTypes.length === 0) return [];

    const parseLeadPrice = value => {
      if (value === null || value === undefined || value === '') return null;
      if (typeof value === 'number') return Number.isFinite(value) ? value : null;
      const numeric = Number(String(value).replace(/,/g, ''));
      return Number.isFinite(numeric) ? numeric : null;
    };
    const leadRaw = config?.schedule?.leadprice ?? config?.schedule?.leaprice;
    const leadPrice = parseLeadPrice(leadRaw);
    const hasLeadPrice = leadPrice !== null && leadPrice > 0;

    const typeMapping = { inside: '인사이드', outside: '오션뷰', balcony: '발코니', suite: '스위트' };
    const safeParlorPrices = Array.isArray(parlorPrices) ? parlorPrices : [];
    const priceMap = safeParlorPrices.reduce((acc, cur) => {
      if (cur.name) acc[cur.name.trim()] = Number(cur.price);
      return acc;
    }, {});

    const uniqueParlorsMap = new Map();

    cabinTypes.forEach(cabin => {
      const cabintypeLower = (cabin.cabintype || '').toLowerCase();
      const nameKr = typeMapping[cabintypeLower] || cabin.cabintype_ko || cabin.cabintype;

      if (!uniqueParlorsMap.has(nameKr)) {
        const rawPrice = priceMap[nameKr] ?? null;
        uniqueParlorsMap.set(nameKr, {
          name: nameKr,
          price: rawPrice !== null
            ? (rawPrice / 2).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
            : (hasLeadPrice ? '$' : '마감'),
          img: cabin.image_url
        });
      }
    });

    return Array.from(uniqueParlorsMap.values());
  }, [config.cabin_types, config?.schedule?.leadprice, config?.schedule?.leaprice, parlorPrices]);

  const [openIdx, setOpenIdx] = useState(null);
  const canReserve = (reservationFlag || '').toUpperCase() !== 'NON';

  const mobileFixedButton = (
    <div className='detail-reservstion-btn-wrapper'>
      {canReserve ? (
        <button type="button" className="btn-reservation btn" onClick={() => { navigate(`/booking/${config.schedule.id}`) }} style={{ marginTop: 0 }}>예약하기</button>
      ) : (
        <div className="reservation-contact-block">
          <p className="reservation-contact-message">{CONTACT_MESSAGE}</p>
          <button
            type="button"
            className="kakao-channel-btn"
            onClick={openKakaoChat}
          >
            카카오톡 채널상담
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div className="detail-body-wrapper">
      {/* 2. CommonNavComponent에 가공된 데이터를 전달합니다. */}
      <CommonNavComponent categories={categoriesWithComponent} />

      {/* 객실정보 */}
      {!isMobile &&
      <div className="sticky-info-wrapper">
        <div className="parlor-info-wrapper">
          <h2 className="parlor-info-title">2인 1실 기준, 1인 최저 요금</h2>
          <div className="parlor-info">
            {parlorPrices == null ? (
              <p>선실 정보를 가져오고 있습니다.</p>
            ) : parlorPrices.length === 0 ? (
              <p>선실 정보가 없습니다.</p>
            ) : parlors.every(room => room.price === '준비중') ? (
              <p>선실 정보를 가져오고 있습니다.</p>
            ) : SHOW_PARLOR_IMAGES ? (
              parlors.map((room, idx) => (
                <React.Fragment key={room.name}>
                  <div className={`folidng${openIdx === idx ? ' open' : ''}`}
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}>
                    <div className="folding-header">
                      <div className="folding-header-arrow">
                        <span>{room.name}</span>
                        <img src={circleArrow} className={`arrow${openIdx === idx ? ' open' : ''}`} alt="toggle" />
                      </div>
                      <span>{room.price}</span>
                    </div>
                    {openIdx === idx && (
                      <div className="folding-content">
                        <img
                          src={room.img}
                          alt={room.name}
                          onError={(event) => {
                            if (event?.currentTarget) {
                              event.currentTarget.style.display = 'none';
                            }
                          }}
                        />
                      </div>
                    )}
                  </div>
                  {idx !== parlors.length - 1 && openIdx !== idx && (
                    <div className="parlor-divider" />
                  )}
                </React.Fragment>
              ))
            ) : (
              parlors.map((room, idx) => (
                <React.Fragment key={room.name}>
                  <div className="folidng simple">
                    <div className="folding-header">
                      <div className="folding-header-arrow">
                        <span>{room.name}</span>
                      </div>
                      <span>{room.price}</span>
                    </div>
                  </div>
                  {idx !== parlors.length - 1 && <div className="parlor-divider" />}
                </React.Fragment>
              ))
            )}
          </div>
        </div>
        {canReserve ? (
          <button type="button" className="btn-reservation" onClick={() => { navigate(`/booking/${config.schedule.id}`) }} >예약하기</button>
        ) : (
          <div className="reservation-contact-block">
            <p className="reservation-contact-message">{CONTACT_MESSAGE}</p>
            <button
              type="button"
              className="kakao-channel-btn"
              onClick={openKakaoChat}
            >
              카카오톡 채널상담
            </button>
          </div>
        )}
      </div>
      }

      {/* 하단 고정 버튼 - 모바일 */}
      {isMobile && portalContainer && ReactDOM.createPortal(mobileFixedButton, portalContainer)}
    </div>
  );
}

export default DetailBody;
